import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import bn from './bn.json';

const STORAGE_KEY = 'haier-pos-lang';

export const defaultLanguage = 'en';
export const supportedLanguages = ['en', 'bn'] as const;
export type Language = (typeof supportedLanguages)[number];

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    bn: { translation: bn },
  },
  lng: (localStorage.getItem(STORAGE_KEY) as Language) ?? defaultLanguage,
  fallbackLng: defaultLanguage,
  interpolation: { escapeValue: false },
});

export const changeLanguage = (lang: Language): void => {
  localStorage.setItem(STORAGE_KEY, lang);
  void i18n.changeLanguage(lang);
};

export default i18n;
